import { Routes, Route } from "react-router-dom";

import Navbar from "./layout/Navbar";
import Home from "./pages/Home";
import UploadPortal from "./pages/UploadPortal";
import Upload from "./pages/Upload";
import ContractPortal from "./pages/ContractPortal";
import ContractPreview from "./pages/ContractPreview";
import ErrorPage from "./common/ErrorPage";
import ThankYouPage from "./pages/ThankYouPage";
import ContractSigned from "./pages/ContractSigned";
import ContractRejected from "./pages/ContractRejected";
import CallBack from "./pages/CallBack";
import { ToastContainer } from "react-toastify";
import * as DOMPurify from "isomorphic-dompurify";
import WaiverPage from "./pages/WaiverPage";
import ContractSignedWaiver from "./pages/ContractSignedWaiver";
import WaiverPageV2 from "./pages/WaiverPageV2";

import "./assets/css/global.css";

function App() {
  //Get URL Parameters
  const queryParameters = new URLSearchParams(window.location.search);
  const guid = queryParameters.get("guid");
  const guidSanatized = DOMPurify.sanitize(guid || "");

  //  DOMPurify.sanitize(guid|| "");

  //Get style from Outsystems Calculator_BO
  var linkNode = document.createElement("link");
  linkNode.href = process.env.REACT_APP_BASE_API_URL + "/css/" + guid;
  linkNode.type = "text/css";
  linkNode.rel = "stylesheet";
  linkNode.charset = "UTF-8";
  document.head.appendChild(linkNode);

  return (
    <div className="wrapper">
      <Navbar />
      <div className="">
        <Routes>
          <Route path="/UploadPortal" element={<UploadPortal />} />
          <Route path="/Upload" element={<Upload />} />
          <Route path="/ContractPortal" element={<ContractPortal />} />
          <Route path="/ContractPreview" element={<ContractPreview />} />
          <Route path="/ThankYouPage" element={<ThankYouPage />} />
          <Route path="/ContractRejected" element={<ContractRejected />} />
          <Route path="/ContractSigned" element={<ContractSigned />} />
          <Route path="/*" element={<ErrorPage />} />
          <Route path="/Callback" element={<CallBack />} />
          <Route path="/WaiverPageV2" element={<WaiverPage />} />
          <Route path="/WaiverPage" element={<WaiverPageV2 />} />
          <Route path="/ContractSignWaiver" element={<ContractSignedWaiver />} />
        </Routes>
        <ToastContainer
          autoClose={3000}
          draggable={false}
          position="top-right"
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnHover
        />
      </div>
    </div>
  );
}

export default App;